export const RegisterValues = {
  email: "",
  password: "",
  passwordConfirm: "",
};

export const formFields: Array<{
  id: string;
  label: string;
  type: "text" | "password" | "email";
  value: string;
}> = [
  {
    id: "email",
    label: "Email",
    type: "text",
    value: RegisterValues.email,
  },
  {
    id: "password",
    label: "Password",
    type: "password",
    value: RegisterValues.password,
  },
  {
    id: "passwordConfirm",
    label: "Confirm Password",
    type: "password",
    value: RegisterValues.passwordConfirm,
  },
];
